// Type de distributeur
enum SMACertificateEnum
{
    SUPPLIER = 0,       // D = Distributeur. Si D est sélectionné alors on traite tous les distributeurs
    ENEDIS = 1,         // Enedis. Traite seulement les requêtes ENEDIS
    GRDF = 2,           // GRDF. Traite seulement les requêtes GRDF
    SRD = 3,              // SRD. Traite seulement les requêtes SRD
    ESL = 4,              // ESL. Traite seulement les requêtes ESL
    GEREDIS = 5,              // GEREDIS. Traite seulement les requêtes GEREDIS
    SER = 7,               // SER. Strasbourg Électricité Réseaux
    REGAZ = 8,             // Régaz (gaz). Traite seulement les requêtes Régaz
    RESEDA = 9,              // Réséda. Traite seulement les requêtes Réséda
    SolarEdge = 6,             // SolarEdge. Traite seulement les requêtes SolarEdge
    GreenAlp = 10             // GreenAlp. Traite seulement les requêtes GreenAlp
}

export default SMACertificateEnum;